import { render, staticRenderFns } from "./ModalLogin.vue?vue&type=template&id=0d4c4466"
import script from "./ModalLogin.vue?vue&type=script&lang=ts"
export * from "./ModalLogin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports